import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ImageViewerData {
  url: string;
  name: string;
  type: string;
}

@Injectable({
  providedIn: 'root'
})
export class ImageViewerService {

  private readonly _image = new BehaviorSubject<ImageViewerData | null>(null);

  readonly image$ = this._image.asObservable();

  open(image: ImageViewerData): void {
    this._image.next(image);
  }

  close(): void {
    this._image.next(null);
  }
}